
  class TemplateBlogJS {
    constructor() {
      this._domEvents();
    }

    /**
     * Dom event listeners
     */
    _domEvents(){
        let getLLinks = document.querySelectorAll('[data-displayCategory]');
        getLLinks.forEach( ele => {
            ele.addEventListener('click' , (event) => {
                event.preventDefault();
                let tag = event.target.closest('[data-bloghref]').getAttribute('data-bloghref');
                this._filterBlogs(tag);
            })
        })
    }

    /**
     * 
     * @param {*} tag - artcle category tag
     * fetch the response of tag based blog filtering
     */
    _filterBlogs(tag){
        let blogURL;
        document.querySelectorAll('[data-bloghref]').forEach( ele => {
            ele.classList.remove('active');
        })
         document.querySelector(`[data-bloghref="${tag}"]`).classList.contains('active');
        document.querySelector(`[data-bloghref="${tag}"]`).classList.add('active');
        tag == 'all_articles' ?  blogURL = `/blogs/blog/` : blogURL = `/blogs/blog/tagged/${tag}`;
        fetch(blogURL).then(response => {
          return response.text();
        }).then(response => {
            this._displayData(response);
        }).catch((e) => {
            console.error(e);
        }).finally(() => {
        });
    }

    /**
     * 
     * @param {*} response - filtered text response 
     * Display the blog filtered data
     */
    _displayData(response){
        let blogHTML,articleHTML,replaceHTML  = '';
        let parser = new DOMParser();
        blogHTML = parser.parseFromString(response, "text/html");
        articleHTML = blogHTML.querySelector('[data-articlesList]')
        replaceHTML = document.querySelector('[data-articlesList]');
        replaceHTML.innerHTML = `${articleHTML.innerHTML}`
    }
}

typeof TemplateBlogJS !== 'undefined' && new TemplateBlogJS();
